import React, { useState,useEffect } from 'react'
import "../styles/workorderDashboard.css"
import Button from './../components/Buttons/Button';
import { Modal, Table, Tooltip } from 'antd';
import { Tabs } from 'antd';
import type { TabsProps } from 'antd';
import CreateOrderRequestForm from '../containers/createOrderForm/createOrderForm';
import Workordertab from '../containers/workordertab/workOrdertab';
import SowDetailsContainer from '../containers/SowDetails/sowDetailsContainer';
import OpportunityMappingForm from '../containers/OpportunityMapping/opportunityMapping';
import ConfirmPopupForm from '../containers/confirmPopup/confirmPopupForm';
import { fetchDuplicateSowDetails, fetchSowDetails_Request, setConfirmPopUpModalIsOpen, setOpportunityModalIsOpen, setPOMappingModalIsOpen, setWorkOrderModalIsOpen, setWorkOrderSelectedSOW } from '../store/reducers/orderDashboardSlice';
import { useDispatch, useSelector } from 'react-redux';
import { checkAccess, getUserRole, isCRF_or_Amendment } from '../utilities/CommonHelper';
import { getUserAccessData } from '../utilities/sessionHelper';
import PoMappingModal from '../containers/PoMappingModal/poMappingModal';
import moment from 'moment';
import MyWorkOrdersTab from '../containers/MyWorkOrdersTab/myWorkOrders';
import TaggedSowContainer from '../containers/TaggedSowContainer/taggedSowContainer';





const OrderDashboard = () => {
  const dispatch = useDispatch();
  const orderDashboardData = useSelector((state: any) => state.orderDashboard);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isMapModalOpen, setIsMapModalOpen] = useState(false);
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  const [selectedSOW, setSelectedSOW] = useState<any>({});
  const [action, setAction] = useState<any>("");
  const [activetab,setactiveTab]=React.useState<string>('1');
  const [confirmPopUpData, setConfirmPopUpData] = useState<any>({});
  const[refreshWorkOrderTable,setRefreshWorkOrderTable]=useState<boolean>(false);
  const role= getUserRole(getUserAccessData()?.roleAccessMap)||"";
  const writeAccess_order:boolean=checkAccess(role,"Order Dashboard",getUserAccessData()?.roleAccessMap[role],"write");

  const { confirm } = Modal; 

  useEffect(() => {
console.log(isMapModalOpen,isModalOpen,isConfirmModalOpen,selectedSOW,activetab)
  }, [isModalOpen,isMapModalOpen,isConfirmModalOpen,selectedSOW,activetab])

  useEffect(() => {
    setSelectedSOW(orderDashboardData.opportunityModal.selectedSOW);
    setIsMapModalOpen(orderDashboardData.opportunityModal.isModalOpen);
  },[orderDashboardData.opportunityModal.selectedSOW,orderDashboardData.opportunityModal.isModalOpen])
  
  useEffect(() => {
    setConfirmPopUpData(orderDashboardData.confirmPopUpModal.confirmPopUpData);
    setIsConfirmModalOpen(orderDashboardData.confirmPopUpModal.isModalOpen);

  },[orderDashboardData.confirmPopUpModal.confirmPopUpData,orderDashboardData.confirmPopUpModal.isModalOpen]);

  useEffect(() => {
    setSelectedSOW(orderDashboardData.workOrder.selectedSOW);
  },[orderDashboardData.workOrder.selectedSOW])

  useEffect(() => {
    setIsModalOpen(orderDashboardData.workOrderModal.isModalOpen);
  },[orderDashboardData.workOrderModal.isModalOpen]);
  const showConfirmModal = () => {
    console.log("selected SOW",selectedSOW);
    let diff = moment(selectedSOW?.sowEndDate).diff(selectedSOW?.sowStartDate,'days');

    validate_isDuplicate(selectedSOW);

    // if(diff>365){
    //       setIsConfirmModalOpen(true);
    // }
    // else{
    //   setIsModalOpen(true);
    //   dispatch(setWorkOrderModalIsOpen({isModalOpen:true,type:"create",data:{}}));
    // }
    // setIsModalOpen(true);
    // dispatch(setWorkOrderModalIsOpen({isModalOpen:true,type:"create",data:{}}));


  }

  const validate_isDuplicate=(selectedSOW:any)=>{

    dispatch(fetchDuplicateSowDetails({sowId:selectedSOW.sowId})).
    then((res:any)=>{
      if(res.type==="orderDashboard/fetchDuplicateSowDetails/fulfilled"){
        if(res.payload.length>0){

          confirm({
            className: 'WorkOrderExistModal',
            title: < span>Are you sure you want to proceed?</span>,
            content: <>
                <span style={{ textAlign: 'justify', display: 'block' }
                }> This SOW {selectedSOW.sowId} might be duplicate SOW of</span >
                {
                    < Table
                        style={{ margin: '10px 0' }}
                        showHeader={true}
                        scroll={{ y: 240, x: 800}}
                        // title={() => <span style={{
                        //     display: 'block',
                        //     textAlign: 'center',
                        //     fontWeight: '600',
                        //     // fontStyle: 'italic',
                        // }}>Details of existing Work Orders</span>}
                        bordered columns={
                            [
                                {
                                    title: 'SOW ID',
                                    dataIndex: 'sowId',
                                    key: 'sowId',
                                    width:150
                                },
                                {
                                  title: 'SOW Name',
                                  dataIndex: 'sowName',
                                  key: 'sowName',
                                  width:150
                                },
                                {
                                    title: 'Client Entity',
                                    dataIndex: 'clientEntity',
                                    key: 'clientEntity',
                                    width:150
                                },
                                {
                                  title: 'Base Currency',
                                  dataIndex: 'currency',
                                  key: 'currency',
                                  width:150
                              },
                                {
                                    title: 'Total Contract Value (LCY)',
                                    dataIndex: 'contractValue',
                                    key: 'contractValue',
                                    width:150
                                },

                            ]} dataSource={res.payload || []} pagination={false} />
                }
                <span style={{ textAlign: 'justify', display: 'block' }}>If duplicate, please mark the same. </span>

            </>,
            okText: 'Proceed with Creation',
            width: 800,
            okType: 'danger',
            styles:{content: {
              borderRadius: '0',
              borderTop: '4px solid #1677ff',
              font: 'normal normal normal 14px/20px Nunito Sans',
              zIndex: 9998,
            },},
            cancelText: 'Cancel',
            onOk: () => {
              setIsModalOpen(true);
              dispatch(setWorkOrderModalIsOpen({isModalOpen:true,type:"create",data:{}}));
            },
            onCancel: () => {

            },
        });
        }
        else{
          setIsModalOpen(true);
          dispatch(setWorkOrderModalIsOpen({isModalOpen:true,type:"create",data:{}}));
        }
      }
    });

  }
  const showMapModal = (record:any,action:any) => {
    if(record){
      console.log("selected SOW",record);
      dispatch(setOpportunityModalIsOpen({isModalOpen:true,selectedSOW:record,action:action}));
      setSelectedSOW(record);
      setAction(action);
      setIsMapModalOpen(true);
    }
    
  };
const handlemapmodel=() => {
  dispatch(setOpportunityModalIsOpen({isModalOpen:false,selectedSOW:{},action:""}));
  setIsMapModalOpen(false);
  setSelectedSOW({});
  setAction("");
};
  const handleOk = () => {
    dispatch(setWorkOrderModalIsOpen({isModalOpen:false,type:"create",data:{}}));
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    dispatch(setWorkOrderModalIsOpen({isModalOpen:false,type:"create",data:{}}));
    setIsModalOpen(false);
  };

  const handleConfirmOk = () => {
    setIsConfirmModalOpen(false);
    setIsModalOpen(true);
    dispatch(setWorkOrderModalIsOpen({isModalOpen:true,type:"create",data:{}}));
  }

  const handleConfirmCancel = () => {
    dispatch(setConfirmPopUpModalIsOpen({isModalOpen:false,confirmPopUpData:{}}));
    dispatch(setWorkOrderModalIsOpen({isModalOpen:false,type:"create",data:{}}));
    setIsConfirmModalOpen(false);
    setIsModalOpen(false);
  }
  const onChange = (key: string) => {
    setactiveTab(key);
  };
  const showWorkOrderTab = (record:any,flag:boolean) => {
    if(flag){
      if(record){
        console.log("selected SOW",record);
        dispatch(setWorkOrderSelectedSOW(record));
        setSelectedSOW(record);
        // setIsMapModalOpen(true);
        setactiveTab('2');
      }
    }
    else{
      dispatch(setWorkOrderSelectedSOW({}));
      setSelectedSOW({});
    }
  }


const handleRefreshWorkOrderTable=()=>{
  setRefreshWorkOrderTable(!refreshWorkOrderTable);
}
const handlePOMappingSucess=()=>{
    dispatch(setPOMappingModalIsOpen({isModalOpen:false,selectedWorkOrder:{}}));
    setRefreshWorkOrderTable(!refreshWorkOrderTable);
}

const handlePOUnmappingSuccess=()=>{
  // dispatch(setPOMappingModalIsOpen({isModalOpen:false,selectedWorkOrder:{}}));
  setRefreshWorkOrderTable(!refreshWorkOrderTable);
}

const  isCreateWorkOrderEnabled =()=>{
  if(writeAccess_order && selectedSOW && Object.keys(selectedSOW).length>0){
    if(isCRF_or_Amendment( selectedSOW?.contractType)){
      return true;
    }
    else{
      return false;
    }
    // if(Object.keys(selectedSOW).length>0){
    //   if(moment().isBefore(moment(selectedSOW?.sowEndDate))){
    //     return false;  
    //   }
    // }
  }
  return true;
}
  const items: TabsProps['items'] = [
    {
      key: '1',
      label: 'SOW Details',
      children: <SowDetailsContainer showMapModal={showMapModal} showWorkOrderTab={showWorkOrderTab} activeTab={activetab}/>,
    },
    {
      key: '2',
      label: 'Work Orders',
      children: <div className='containerr'>
      <div className='row'>
        <h2 className='col-lg-6 col-sm-12 page-heading'>
          WORK ORDER DASHBOARD
        </h2>
        <div className='col-lg-6 col-sm-12 text-end pt-3'>
          <Tooltip title={selectedSOW.child?"This SOW is a Child SOW. Please tag it to the Master SOW.":""}>
          <Button label="Create Work Order" disabled={isCreateWorkOrderEnabled()|| selectedSOW.child} width='200px' height='40px' type="submit" onClick={showConfirmModal} />
          </Tooltip>
        </div>
      </div>

      <Workordertab _selectedSOWDetails={selectedSOW} activeTab={activetab} refreshTable={refreshWorkOrderTable} handleRefreshTable={handleRefreshWorkOrderTable}/>
    </div>,
    },
    {
      key: '3',
      label: 'My Work Orders',
      children: <div className='containerr'>
      <div className='row'>
        <h2 className='col-lg-6 col-sm-12 page-heading'>
          MY WORK ORDERS
        </h2>
      </div>

      <MyWorkOrdersTab  activeTab={activetab} refreshTable={refreshWorkOrderTable} handleRefreshTable={handleRefreshWorkOrderTable}/>
    </div>,
    },
    {
      key: '4',
      label: 'Tagged SOW Details',
      children: 
      <TaggedSowContainer showMapModal={showMapModal} showWorkOrderTab={showWorkOrderTab} activeTab={activetab}/>,
    },
  ];
  return (
    <><>
      <div className='containerr' style={{marginLeft:'10px', marginRight:'10px'}}>
        <Tabs defaultActiveKey="1" activeKey={activetab} items={
         role==="Finance"?
         items:
          items.filter((item)=>item.key!=="3")
          } onChange={onChange} />
      </div>

      <Modal title={orderDashboardData.workOrderModal.type==="create"?"Create Work Order": "Edit Work Order"} 
      open={isModalOpen} 
      onCancel={handleCancel} 
      width={1350} 
      styles={{
        content: {
          borderRadius: '0',
          borderTop: '4px solid #1677ff',
          font: 'normal normal normal 14px/20px Nunito Sans',
        },
      }}
      footer={null}>
        <CreateOrderRequestForm onSubmit={function (): void {
          handleOk()
          setRefreshWorkOrderTable(true);
        } } onCancel={function (): void {
          handleCancel()
          // throw new Error('Function not implemented.');
        } }
        confirmPopUpData={confirmPopUpData}
        selectedSOW={selectedSOW}></CreateOrderRequestForm>
      </Modal>
      <Modal 
      title="Confirmation Popup"
      open={isConfirmModalOpen}
      onOk={handleConfirmOk} 
      onCancel={handleConfirmCancel}  
      styles={{
        content: {
          borderRadius: '0',
          borderTop: '4px solid #1677ff',
          font: 'normal normal normal 14px/20px Nunito Sans',
        },
      }}
      footer={null}>
        <ConfirmPopupForm onSubmit={function (): void {
          handleConfirmOk()
        } } onCancel={function (): void {
          handleConfirmCancel()
          // throw new Error('Function not implemented.');
        } }
        selectedSOW={selectedSOW}></ConfirmPopupForm>
      </Modal>
      </>
      <Modal 
      title={action==="relink"?"Relink Opportunity": action==="view"? "View Linked Opportunity Details": "Link Opportunity" } 
      open={isMapModalOpen} 
      // onOk={handlemapmodel} 
      onCancel={(handlemapmodel)} 
      width={1400} 
      footer={null}
      styles={{
        content: {
          borderRadius: '0',
          borderTop: '4px solid #1677ff',
          font: 'normal normal normal 14px/20px Nunito Sans',
        },
      }}>
      {/* <Table columns={columns} dataSource={data} scroll={{ x: 1500, y: 300 }} /> */}
      <OpportunityMappingForm 
        onSubmit={()=>{
          handlemapmodel();
          dispatch(fetchSowDetails_Request());

        }}
        onCancel={()=>handlemapmodel()}
        selectedSOW={selectedSOW}
        action ={action}
        isOpen={isMapModalOpen}></OpportunityMappingForm>
        </Modal>
        <PoMappingModal onPOMappingSuccess={handlePOMappingSucess} onPOUnmappingSuccess={handlePOUnmappingSuccess} handleRefreshWorkOrderTable={handleRefreshWorkOrderTable}/>
        </>
  )
}
export default OrderDashboard;